<ng-container [formGroup]="form">
  <nz-form-item>
    <div class="form-desc">
      Are there &nbsp;
      <button
        nz-button
        type="button"
        nzType="text"
        class="primary-text-btn link-btn"
        (click)="openSettingEvents.emit()">
        Setting Events
      </button>
      &nbsp;associated with the behavior? Select all that apply.
      <span *ngIf="isRequired" class="error-text">*</span>
    </div>
    <div class="checkbox-wrapper">
      <span
        *ngFor="
          let setting of behaviourSettingEventList | orderBy: 'sequenceNumber';
          trackBy: trackById
        "
        nz-checkbox
        [nzChecked]="
          form.get('caseBehaviorSettingEventIds')?.value?.includes(setting.id)
        "
        (nzCheckedChange)="
          onCheckboxChange('caseBehaviorSettingEventIds', $event, setting.id)
        "
        [nzValue]="setting.id">
        {{ setting.name }}
      </span>
    </div>
    <div
      class="ant-form-item-explain-error mt-3"
      *ngIf="form.get('caseBehaviorSettingEventIds')?.hasError('required')">
      Please select at least 1 behavior setting event.
    </div>
  </nz-form-item>
</ng-container>
